import { render, staticRenderFns } from "./CampaignsEmails.vue?vue&type=template&id=79def0ea"
import script from "./CampaignsEmails.vue?vue&type=script&lang=js"
export * from "./CampaignsEmails.vue?vue&type=script&lang=js"
import style0 from "./CampaignsEmails.vue?vue&type=style&index=0&id=79def0ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports